export const AUTH_STATE_CHANGE = 'AUTH_STATE_CHANGE'
export const AUTH_STATE_CHANGE_SUCCESS = 'AUTH_STATE_CHANGE_SUCCESS'
export const AUTH_STATE_CHANGE_ERROR = 'AUTH_STATE_CHANGE_ERROR'

export const authStateChange = (data) => ({
  type: AUTH_STATE_CHANGE,
  payload: data
})
